export const TECHNICAL_INTERVENTION_STATUS = {
  NONE: 'None',
  SCHEDULED: 'Scheduled',
  PLANNED: 'Planned',
  PLANNING_COMMENT: 'PlanningComment',
  DISPATCHED: 'Dispatched',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  FINISHED: 'Finished',
  CANNOT_COMPLETE: 'CannotComplete',
  CANCELED: 'Canceled',
  NEW: 'New',
  ASSIGNED: 'Assigned',
  ON_THE_WAY: 'OnTheWay',
  REPAIRED: 'Repaired',
  REPAIR_REFUSED_BY_CUSTOMER: 'RepairRefusedByCustomer',
  QUOTE_TO_BE_ISSUED: 'QuoteToBeIssued',
  QUOTE_ISSUED: 'QuoteIssued',
  SPARE_PART_REQUEST_TO_BE_MADE: 'SparePartRequestToBeMade',
  SPARE_PART_REQUEST_DONE: 'SparePartRequestDone',
  IN_TESTING: 'InTesting',
  RECORDER_DEPOSIT_REQUEST: 'RecorderDepositRequest',
  RECORDER_DEPOSIT_DONE: 'RecorderDepositDone',
  TECHNICALLY_IRREPARABLE: 'TechnicallyIrreparable',
  ECONOMICALLY_IRREPARABLE: 'EconomicallyIrreparable',
  WAITING_FOR_ADDITIONAL_INFORMATION: 'WaitingForAdditionalInformation',
  WORKSHOP_RETURN_REQUESTED: 'WorkshopReturnRequested',
  WORKSHOP_RETURN_DONE: 'WorkshopReturnDone',
  LOAN_DEPOSIT_REQUESTED: 'LoanDepositRequested',
  NEW_APPOINTMENT_TO_BE_SCHEDULED: 'NewAppointmentToBeScheduled',
  CUSTOMER_ABSENT: 'CustomerAbsent',
  INTERVENTION_REFUSED_BY_CUSTOMER: 'InterventionRefusedByCustomer',
  WRONG_CUSTOMER_ADDRESS: 'WrongCustomerAddress',
  SPARE_PART_ISSUE: 'SparePartIssue',
  INACCESSIBLE_PRODUCT: 'InaccessibleProduct',
  TECHNICIAN_UNFORESEEN: 'TechnicianUnforeseen',
  TEST_IN_PROGRESS: 'TestInProgress',
  PICKUP: 'Pickup',
  VACATION: 'Vacation',
  UNREPAIRABLE_PRODUCT: 'UnrepairableProduct',
  WAITING_FOR_CLIENT_RESPONSE_ON_QUOTE: 'WaitingForClientResponseOnQuote',
  WAITING_FOR_DECISION: 'WaitingForDecision',
  WAITING_FOR_SPARE_PART: 'WaitingForSparePart',
  REJECT_WARRANTY: 'RejectWarranty',
} as const;

export type TechnicalInterventionStatus =
  (typeof TECHNICAL_INTERVENTION_STATUS)[keyof typeof TECHNICAL_INTERVENTION_STATUS];

export const TechnicalInterventionStatusMap = {
  Scheduled: [
    TECHNICAL_INTERVENTION_STATUS.SCHEDULED,
    'Planifié',
    TECHNICAL_INTERVENTION_STATUS.PLANNED,
  ],
};

export interface TechnicalIntervention {
  startTimeUtc?: string;
  endTimeUtc?: string;
  status: TechnicalInterventionStatus;
  description: string;
  createdDate: string;
  isReSchedulable?: boolean;
  scheduleStartTimeUtc?: string;
  scheduleEndTimeUtc?: string;
  workType?: {
    id: string;
    label: string;
  };
  id: string;
}
